import React, { Children } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import { Redirect } from "react-router-dom";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import LocalCafeIcon from '@material-ui/icons/LocalCafe';
import ScheduleIcon from "@material-ui/icons/Schedule";
import BeachAccessIcon from "@material-ui/icons/BeachAccess";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import { useLocation } from 'react-router-dom'
import InboxIcon from "@material-ui/icons/Inbox";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles({
  root: {
    width: "100%",
    position: "fixed",
    bottom: 0,
    textAlign: "center",
  },
  thinMarings: {
    padding: "2px",
    minWidth: 70,
  }
});


function BottomNavigations(props) {
  const classes = useStyles();
  const location = useLocation();
  const [value, setValue] = React.useState(0);
  const history = useHistory();

  const changeBottonNavigationValue = (value) => {
    setValue(value);
    switch (value) {
      case '/inbox':
        history.push("/inbox");
        break;
      case '/next':
        history.push("/next");
        break;
      case '/wating':
        history.push("/wating");
        break;
      case '/scheduled':
        history.push("/scheduled");
        break;
      case '/someday':
        history.push("/someday");
        break;
      case '/focus':
        history.push("/focus");
        break;
    }
  }

  return props.user && (

    <BottomNavigation
      // value={props.currentLocation}
      onChange={(event, newValue) => {
        changeBottonNavigationValue(newValue);
      }}
      showLabels
      className={classes.root}
    >
      <BottomNavigationAction classes={{ root: classes.thinMarings }} label="Inbox" value="/inbox" icon={<InboxIcon />} />
      <BottomNavigationAction classes={{ root: classes.thinMarings }} label="Focus" value="/focus" icon={<StarBorderIcon />} />
      <BottomNavigationAction classes={{ root: classes.thinMarings }} label="Next" value="/next" icon={<ArrowForwardIosIcon />} />
      <BottomNavigationAction classes={{ root: classes.thinMarings }} label="Waiting" value="/wating" icon={<LocalCafeIcon />} />
      <BottomNavigationAction classes={{ root: classes.thinMarings }} label="Scheduled" value="/scheduled" icon={<ScheduleIcon />} />
      <BottomNavigationAction classes={{ root: classes.thinMarings }} label="Someday" value="/someday" icon={<BeachAccessIcon />} />

    </BottomNavigation>
  );
}


const mapStateToProps = state => {
  return {
    spinner: state.spinner,
    displaySpinner: state.tasks === "empty",
    user: state.user,
    currentLocation: state.router.location.pathname,
  };
};

export default connect(
  mapStateToProps
)(BottomNavigations)
